import { Component, inject, Input, signal } from '@angular/core';
import {
    FrameworkColumn,
    ITableCellValueRenderer,
    SafeAny,
} from '@pf/shared-common';
import { IItemFragment } from '@pf/shared/util-platform';
import { toObservable } from '@angular/core/rxjs-interop';
import { map, of, switchMap } from 'rxjs';
import { ItemFacade } from '@pf/platform-item-catalog/domain';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'platform-item-preview-renderer',
    template: `
        @if (itemUrl$ | async; as itemUrl) {
            <img
                class="item-preview"
                [ngSrc]="itemUrl"
                width="50"
                height="50"
                [alt]="item()?.name"
                [priority]="true" />
        }
        <div class="item-preview-text">
            <strong>{{ item()?.code }}</strong>
            <span>{{ item()?.name }}</span>
        </div>
    `,
    styles: [
        `
            :host {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: var(--pf-gap);

                .item-preview-text {
                    display: flex;
                    flex-direction: column;
                    font-size: smaller;
                }
            }
        `,
    ],
    standalone: false,
})
export class ItemPreviewRendererComponent implements ITableCellValueRenderer {
    private readonly itemFacade = inject(ItemFacade);

    @Input() set value(item: IItemFragment | null | undefined) {
        this.item.set(item);
    }
    @Input() column!: FrameworkColumn;
    @Input() row!: SafeAny;

    item = signal<IItemFragment | null | undefined>(null);

    itemUrl$ = toObservable(this.item).pipe(
        untilDestroyed(this),
        switchMap(item =>
            item?.id
                ? this.itemFacade.getDefaultItemImage$(item.id as string)
                : of(null)
        ),
        map(file => file?.url)
    );
}
